import { InterviewEventSource } from '../helpers/interviewEventHelpers'

export const FETCH_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestDetails/FETCH_INTERVIEW_REQUEST'
export const FETCH_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_INTERVIEW_REQUEST_SUCCESS'
export const FETCH_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_INTERVIEW_REQUEST_ERROR'

export const FETCH_GREENHOUSE_PROFILE = 'companyExperience/views/interviewRequestDetails/FETCH_GREENHOUSE_PROFILE'
export const FETCH_GREENHOUSE_PROFILE_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_GREENHOUSE_PROFILE_SUCCESS'
export const FETCH_GREENHOUSE_PROFILE_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_GREENHOUSE_PROFILE_ERROR'

export const FETCH_COMPETING_INTERVIEW_REQUESTS = 'companyExperience/views/interviewRequestDetails/FETCH_COMPETING_INTERVIEW_REQUESTS'
export const FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS =
  'companyExperience/views/interviewRequestDetails/FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS'
export const FETCH_COMPETING_INTERVIEW_REQUESTS_ERROR =
  'companyExperience/views/interviewRequestDetails/FETCH_COMPETING_INTERVIEW_REQUESTS_ERROR'

export const FETCH_CANDIDATE_AVAILABILITIES = 'companyExperience/views/interviewRequestDetails/FETCH_CANDIDATE_AVAILABILITIES'
export const FETCH_CANDIDATE_AVAILABILITIES_SUCCESS =
  'companyExperience/views/interviewRequestDetails/FETCH_CANDIDATE_AVAILABILITIES_SUCCESS'
export const FETCH_CANDIDATE_AVAILABILITIES_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_CANDIDATE_AVAILABILITIES_ERROR'

export const FETCH_MESSAGES = 'companyExperience/views/interviewRequestDetails/FETCH_MESSAGES'
export const FETCH_MESSAGES_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_MESSAGES_SUCCESS'
export const FETCH_MESSAGES_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_MESSAGES_ERROR'

export const CREATE_MESSAGE = 'companyExperience/views/interviewRequestDetails/CREATE_MESSAGE'
export const CREATE_MESSAGE_SUCCESS = 'companyExperience/views/interviewRequestDetails/CREATE_MESSAGE_SUCCESS'
export const CREATE_MESSAGE_ERROR = 'companyExperience/views/interviewRequestDetails/CREATE_MESSAGE_ERROR'
export const UPDATE_MESSAGE = 'companyExperience/views/interviewRequestDetails/UPDATE_MESSAGE'
export const UPDATE_MESSAGE_SUCCESS = 'companyExperience/views/interviewRequestDetails/UPDATE_MESSAGE_SUCCESS'
export const UPDATE_MESSAGE_ERROR = 'companyExperience/views/interviewRequestDetails/UPDATE_MESSAGE_ERROR'

export const WITHDRAW_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestDetails/WITHDRAW_INTERVIEW_REQUEST'
export const WITHDRAW_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestDetails/WITHDRAW_INTERVIEW_REQUEST_SUCCESS'
export const WITHDRAW_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestDetails/WITHDRAW_INTERVIEW_REQUEST_ERROR'

export const ARCHIVE_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestDetails/ARCHIVE_INTERVIEW_REQUEST'
export const ARCHIVE_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestDetails/ARCHIVE_INTERVIEW_REQUEST_SUCCESS'
export const ARCHIVE_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestDetails/ARCHIVE_INTERVIEW_REQUEST_ERROR'

export const UPDATE_INTERVIEW_REQUEST = 'companyExperience/views/interviewRequestDetails/UPDATE_INTERVIEW_REQUEST'
export const UPDATE_INTERVIEW_REQUEST_SUCCESS = 'companyExperience/views/interviewRequestDetails/UPDATE_INTERVIEW_REQUEST_SUCCESS'
export const UPDATE_INTERVIEW_REQUEST_ERROR = 'companyExperience/views/interviewRequestDetails/UPDATE_INTERVIEW_REQUEST_ERROR'

export const FETCH_INTERVIEW_EVENTS = 'companyExperience/views/interviewRequestDetails/FETCH_INTERVIEW_EVENTS'
export const FETCH_INTERVIEW_EVENTS_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_INTERVIEW_EVENTS_SUCCESS'
export const FETCH_INTERVIEW_EVENTS_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_INTERVIEW_EVENTS_ERROR'

export const CREATE_INTERVIEW_EVENT = 'companyExperience/views/interviewRequestDetails/CREATE_INTERVIEW_EVENT'
export const CREATE_INTERVIEW_EVENT_SUCCESS = 'companyExperience/views/interviewRequestDetails/CREATE_INTERVIEW_EVENT_SUCCESS'
export const CREATE_INTERVIEW_EVENT_ERROR = 'companyExperience/views/interviewRequestDetails/CREATE_INTERVIEW_EVENT_ERROR'

export const FETCH_EVENT_FEEDBACKS = 'companyExperience/views/interviewRequestDetails/FETCH_EVENT_FEEDBACKS'
export const FETCH_EVENT_FEEDBACKS_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_EVENT_FEEDBACKS_SUCCESS'
export const FETCH_EVENT_FEEDBACKS_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_EVENT_FEEDACKS_ERROR'

export const TOGGLE_EVENT_FEEDBACK = 'companyExperience/views/interviewRequestDetails/TOGGLE_EVENT_FEEDBACK'

export const CREATE_EVENT_FEEDBACK = 'companyExperience/views/interviewRequestDetails/CREATE_EVENT_FEEDBACK'
export const CREATE_EVENT_FEEDBACK_SUCCESS = 'companyExperience/views/interviewRequestDetails/CREATE_EVENT_FEEDBACK_SUCCESS'
export const CREATE_EVENT_FEEDBACK_ERROR = 'companyExperience/views/interviewRequestDetails/CREATE_EVENT_FEEDBACK_ERROR'

export const FETCH_OFFERS = 'companyExperience/views/interviewRequestDetails/FETCH_OFFERS'
export const FETCH_OFFERS_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_OFFERS_SUCCESS'
export const FETCH_OFFERS_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_OFFERS_ERROR'

export const CREATE_OFFER = 'companyExperience/views/interviewRequestDetails/CREATE_OFFER'
export const CREATE_OFFER_SUCCESS = 'companyExperience/views/interviewRequestDetails/CREATE_OFFER_SUCCESS'
export const CREATE_OFFER_ERROR = 'companyExperience/views/interviewRequestDetails/CREATE_OFFER_ERROR'

export const FETCH_MEMBERS = 'companyExperience/views/interviewRequestDetails/FETCH_MEMBERS'
export const FETCH_MEMBERS_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_MEMBERS_SUCCESS'
export const FETCH_MEMBERS_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_MEMBERS_ERROR'

export const FETCH_TEAM_NOTES = 'companyExperience/views/interviewRequestDetails/FETCH_TEAM_NOTES'
export const FETCH_TEAM_NOTES_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_TEAM_NOTES_SUCCESS'
export const FETCH_TEAM_NOTES_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_TEAM_NOTES_ERROR'

export const CREATE_TEAM_NOTE = 'companyExperience/views/interviewRequestDetails/CREATE_TEAM_NOTE'
export const CREATE_TEAM_NOTE_SUCCESS = 'companyExperience/views/interviewRequestDetails/CREATE_TEAM_NOTE_SUCCESS'
export const CREATE_TEAM_NOTE_ERROR = 'companyExperience/views/interviewRequestDetails/CREATE_TEAM_NOTE_ERROR'

export const UPDATE_TEAM_NOTE = 'companyExperience/views/interviewRequestDetails/UPDATE_TEAM_NOTE'
export const UPDATE_TEAM_NOTE_SUCCESS = 'companyExperience/views/interviewRequestDetails/UPDATE_TEAM_NOTE_SUCCESS'
export const UPDATE_TEAM_NOTE_ERROR = 'companyExperience/views/interviewRequestDetails/UPDATE_TEAM_NOTE_ERROR'

export const DELETE_TEAM_NOTE = 'companyExperience/views/interviewRequestDetails/DELETE_TEAM_NOTE'
export const DELETE_TEAM_NOTE_SUCCESS = 'companyExperience/views/interviewRequestDetails/DELETE_TEAM_NOTE_SUCCESS'
export const DELETE_TEAM_NOTE_ERROR = 'companyExperience/views/interviewRequestDetails/DELETE_TEAM_NOTE_ERROR'

export const INTERVIEW_REQUEST_POLLING_INIT = 'companyExperience/views/interviewRequestDetails/INTERVIEW_REQUEST_POLLING_INIT'
export const INTERVIEW_REQUEST_POLLING_EXECUTE = 'companyExperience/views/interviewRequestDetails/INTERVIEW_REQUEST_POLLING_EXECUTE'
export const INTERVIEW_REQUEST_POLLING_END = 'companyExperience/views/interviewRequestDetails/INTERVIEW_REQUEST_POLLING_END'

export const FETCH_ACCOUNT_MANAGER = 'companyExperience/views/interviewRequestDetails/FETCH_ACCOUNT_MANAGER'
export const FETCH_ACCOUNT_MANAGER_SUCCESS = 'companyExperience/views/interviewRequestDetails/FETCH_ACCOUNT_MANAGER_SUCCESS'
export const FETCH_ACCOUNT_MANAGER_ERROR = 'companyExperience/views/interviewRequestDetails/FETCH_ACCOUNT_MANAGER_ERROR'

export const fetchInterviewRequest = (id, companySlug) => ({
  type: FETCH_INTERVIEW_REQUEST,
  meta: { id, companySlug },
  payload: {
    fetchingInterviewRequest: true,
    fetchInterviewRequestError: null,
  },
})

export const fetchInterviewRequestSuccess = (id, { result }) => ({
  type: FETCH_INTERVIEW_REQUEST_SUCCESS,
  meta: { id },
  payload: {
    fetchingInterviewRequest: false,
    lastUpdatedInterviewRequest: Date.now(),
    interviewRequest: result.id,
  },
})

export const fetchInterviewRequestError = (id, errorMessage) => ({
  type: FETCH_INTERVIEW_REQUEST_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchGreenhouseProfile = id => ({
  type: FETCH_GREENHOUSE_PROFILE,
  meta: { id },
  payload: {
    fetchingGreenhouseProfile: true,
    fetchGreenhouseProfileError: null,
  },
})

export const fetchGreenhouseProfileSuccess = (id, { result }) => ({
  type: FETCH_GREENHOUSE_PROFILE_SUCCESS,
  meta: { id },
  payload: {
    fetchingGreenhouseProfile: false,
    lastUpdatedGreenhouseProfile: Date.now(),
    greenhouseProfile: result.id,
  },
})

export const fetchGreenhouseProfileError = (id, errorMessage) => ({
  type: FETCH_GREENHOUSE_PROFILE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchCompetingInterviewRequests = id => ({
  type: FETCH_COMPETING_INTERVIEW_REQUESTS,
  meta: { id },
  payload: {
    fetchingCompetingInterviewRequests: true,
    fetchCompetingInterviewRequestsError: null,
  },
})

export const fetchCompetingInterviewRequestsSuccess = (id, { result }) => ({
  type: FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS,
  meta: { id },
  payload: {
    fetchingCompetingInterviewRequests: false,
    lastUpdatedCompetingInterviewRequests: Date.now(),
    competingInterviewRequests: result,
  },
})

export const fetchCompetingInterviewRequestsError = (id, errorMessage) => ({
  type: FETCH_COMPETING_INTERVIEW_REQUESTS_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchCandidateAvailabilities = (id, candidateProfileId) => ({
  type: FETCH_CANDIDATE_AVAILABILITIES,
  meta: { id, candidateProfileId },
  payload: {
    fetchingCandidateAvailabilities: true,
    fetchCandidateAvailabilitiesError: null,
  },
})

export const fetchCandidateAvailabilitiesSuccess = (id, { result }) => ({
  type: FETCH_CANDIDATE_AVAILABILITIES_SUCCESS,
  meta: { id },
  payload: {
    fetchingCandidateAvailabilities: false,
    lastUpdatedCandidateAvailabilities: Date.now(),
    candidateAvailabilities: result.map(availability => availability.id),
  },
})

export const fetchCandidateAvailabilitiesError = (id, errorMessage) => ({
  type: FETCH_CANDIDATE_AVAILABILITIES_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchMessages = id => ({
  type: FETCH_MESSAGES,
  meta: {
    id,
    params: {
      paginate: false,
    },
  },
  payload: {
    fetchingMessages: true,
    fetchMessagesError: null,
  },
})

export const fetchMessagesSuccess = (id, { result }) => ({
  type: FETCH_MESSAGES_SUCCESS,
  meta: { id },
  payload: {
    fetchingMessages: false,
    lastUpdatedMessages: Date.now(),
    messages: result.map(message => message.id),
  },
})

export const fetchMessagesError = (id, errorMessage) => ({
  type: FETCH_MESSAGES_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const createMessage = (id, data, formResolve, formReject) => ({
  type: CREATE_MESSAGE,
  meta: { id, data, formResolve, formReject },
  payload: {
    creatingMessage: true,
    createMessageError: null,
  },
})

export const createMessageSuccess = (id, { result }) => ({
  type: CREATE_MESSAGE_SUCCESS,
  meta: { id },
  payload: {
    creatingMessage: false,
    lastUpdatedMessages: Date.now(),
    messages: [result.id],
  },
})

export const createMessageError = (id, errorMessage) => ({
  type: CREATE_MESSAGE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const updateMessage = (id, messageId, data, formResolve, formReject) => ({
  type: UPDATE_MESSAGE,
  meta: { id, messageId, data, formResolve, formReject },
  payload: {
    updatingMessage: true,
    updateMessageError: null,
  },
})

// Unlike createMessageSuccess this carries no message id: the message is already in the
// ordered list, and adding it again would render the edited message twice.
export const updateMessageSuccess = id => ({
  type: UPDATE_MESSAGE_SUCCESS,
  meta: { id },
  payload: {
    updatingMessage: false,
    lastUpdatedMessages: Date.now(),
  },
})

export const updateMessageError = (id, errorMessage) => ({
  type: UPDATE_MESSAGE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const withdrawInterviewRequest = (companySlug, id, formResolve, formReject) => ({
  type: WITHDRAW_INTERVIEW_REQUEST,
  meta: { companySlug, id, formResolve, formReject },
  payload: {
    withdrawingInterviewRequest: true,
    withdrawInterviewRequestError: null,
  },
})

export const withdrawInterviewRequestSuccess = (id, { result }) => ({
  type: WITHDRAW_INTERVIEW_REQUEST_SUCCESS,
  meta: { id },
})

export const withdrawInterviewRequestError = (id, errorMessage) => ({
  type: WITHDRAW_INTERVIEW_REQUEST_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const archiveInterviewRequest = (id, data) => ({
  type: ARCHIVE_INTERVIEW_REQUEST,
  meta: { id, data },
  payload: {
    archivingInterviewRequest: true,
    archiveInterviewRequestError: null,
  },
})

export const archiveInterviewRequestSuccess = (id, { result }) => ({
  type: ARCHIVE_INTERVIEW_REQUEST_SUCCESS,
  meta: { id },
  payload: {
    archivingInterviewRequest: false,
    lastUpdatedInterviewRequest: Date.now(),
  },
})

export const archiveInterviewRequestError = (id, errorMessage) => ({
  type: ARCHIVE_INTERVIEW_REQUEST_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const updateInterviewRequest = (id, data, previousData) => ({
  type: UPDATE_INTERVIEW_REQUEST,
  meta: { id, data, previousData },
  payload: {
    updatingInterviewRequest: true,
    updateInterviewRequestError: null,
  },
})

export const updateInterviewRequestSuccess = (id, { result }) => ({
  type: UPDATE_INTERVIEW_REQUEST_SUCCESS,
  meta: { id },
  payload: {
    updatingInterviewRequest: false,
    lastUpdatedInterviewRequest: Date.now(),
  },
})

export const updateInterviewRequestError = (id, errorMessage) => ({
  type: UPDATE_INTERVIEW_REQUEST_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchInterviewEvents = id => ({
  type: FETCH_INTERVIEW_EVENTS,
  meta: {
    id,
    sortBy: 'CREATED_AT',
    sortDirection: 'ASC',
    interviewSource: InterviewEventSource.Platform,
  },
  payload: {
    fetchingInterviewEvents: true,
    fetchInterviewEventsError: null,
  },
})

export const fetchInterviewEventsSuccess = (id, results) => ({
  type: FETCH_INTERVIEW_EVENTS_SUCCESS,
  meta: { id },
  payload: {
    fetchingInterviewEvents: false,
    lastUpdatedInterviewEvents: Date.now(),
    interviewEvents: results.map(event => event.id),
  },
})

export const fetchInterviewEventsError = (id, errorMessage) => ({
  type: FETCH_INTERVIEW_EVENTS_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchEventFeedbacks = id => ({
  type: FETCH_EVENT_FEEDBACKS,
  meta: { id },
  payload: {
    fetchingEventFeedbacks: true,
    fetchEventFeedbacksError: null,
  },
})

export const fetchEventFeedbacksSuccess = (id, { result }) => ({
  type: FETCH_EVENT_FEEDBACKS_SUCCESS,
  meta: { id },
  payload: {
    fetchingEventFeedbacks: false,
    lastUpdatedEventFeedbacks: Date.now(),
    eventFeedbacks: result.map(feedback => feedback.id),
    interviewEventStats: result.map(feedback => ({
      meta: { eventId: feedback.interview_event.id },
      payload: {
        eventFeedbackId: feedback.id,
        lastUpdatedEventFeedback: Date.now(),
      },
    })),
  },
})

export const fetchEventFeedbacksError = (id, errorMessage) => ({
  type: FETCH_EVENT_FEEDBACKS_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const createInterviewEvent = (id, candidateId, data, formResolve, formReject) => ({
  type: CREATE_INTERVIEW_EVENT,
  meta: { id, candidateId, data, formResolve, formReject },
  payload: {
    creatingInterviewEvent: true,
    createInterviewEventError: null,
  },
})

export const createInterviewEventSuccess = (id, result) => ({
  type: CREATE_INTERVIEW_EVENT_SUCCESS,
  meta: { id },
  payload: {
    creatingInterviewEvent: false,
    lastUpdatedInterviewEvents: Date.now(),
    interviewEvents: [result.id],
    interviewEventStats: { [result.id]: defaultStats },
  },
})

export const createInterviewEventError = (id, errorMessage) => ({
  type: CREATE_INTERVIEW_EVENT_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const toggleEventFeedback = (id, eventId) => ({
  type: TOGGLE_EVENT_FEEDBACK,
  meta: { id },
  payload: {
    eventToGiveFeedback: eventId,
  },
})

export const createEventFeedback = (id, eventId, data, formResolve, formReject) => ({
  type: CREATE_EVENT_FEEDBACK,
  meta: { id, eventId, data, formResolve, formReject },
  payload: {
    creatingEventFeedback: true,
    createEventFeedbackError: null,
  },
})

export const createEventFeedbackSuccess = (id, eventId, { result }) => ({
  type: CREATE_EVENT_FEEDBACK_SUCCESS,
  meta: { id, eventId },
  payload: {
    eventFeedbacks: [result.id],
    interviewEventStats: {
      creatingEventFeedback: false,
      lastUpdatedEventFeedback: Date.now(),
      eventFeedbackId: result.id,
    },
  },
})

export const createEventFeedbackError = (id, eventId, errorMessage) => ({
  type: CREATE_EVENT_FEEDBACK_ERROR,
  meta: { id, eventId },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchOffers = id => ({
  type: FETCH_OFFERS,
  meta: { id },
  payload: {
    fetchingOffers: true,
    fetchOffersError: null,
  },
})

export const fetchOffersSuccess = (id, { result }) => ({
  type: FETCH_OFFERS_SUCCESS,
  meta: { id },
  payload: {
    fetchingOffers: false,
    lastUpdatedOffers: Date.now(),
    offers: result.map(offer => offer.id),
  },
})

export const fetchOffersError = (id, errorMessage) => ({
  type: FETCH_OFFERS_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const createOffer = (id, data, formResolve, formReject) => ({
  type: CREATE_OFFER,
  meta: { id, data, formResolve, formReject },
  payload: {
    creatingOffer: true,
    createOfferError: null,
  },
})

export const createOfferSuccess = (id, { result }) => ({
  type: CREATE_OFFER_SUCCESS,
  meta: { id },
  payload: {
    creatingOffer: false,
    lastUpdatedOffers: Date.now(),
    offers: [result.id],
  },
})

export const createOfferError = (id, errorMessage) => ({
  type: CREATE_OFFER_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchMembers = id => ({
  type: FETCH_MEMBERS,
  meta: {
    id,
    params: {
      order_by: 'name',
      order_direction: 'asc',
      paginate: false,
    },
  },
  payload: {
    fetchingMembers: true,
    fetchMembersError: null,
  },
})

export const fetchMembersSuccess = (id, { result }) => ({
  type: FETCH_MEMBERS_SUCCESS,
  meta: { id },
  payload: {
    fetchingMembers: false,
    lastUpdatedMembers: Date.now(),
    members: result.map(member => member.id),
  },
})

export const fetchMembersError = (id, errorMessage) => ({
  type: FETCH_MEMBERS_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const fetchTeamNotes = (id, candidateId) => ({
  type: FETCH_TEAM_NOTES,
  meta: {
    id,
    params: {
      candidate_id: candidateId,
      order_by: 'created_at',
      order_direction: 'desc',
      paginate: false,
    },
  },
  payload: {
    fetchingTeamNotes: true,
    fetchTeamNotesError: null,
  },
})

export const fetchTeamNotesSuccess = (id, { result }) => ({
  type: FETCH_TEAM_NOTES_SUCCESS,
  meta: { id },
  payload: {
    fetchingTeamNotes: false,
    lastUpdatedTeamNotes: Date.now(),
    teamNotes: result.map(note => note.id),
  },
})

export const fetchTeamNotesError = (id, errorMessage) => ({
  type: FETCH_TEAM_NOTES_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const createTeamNote = (id, data, formResolve, formReject) => ({
  type: CREATE_TEAM_NOTE,
  meta: { id, data, formResolve, formReject },
  payload: {
    creatingTeamNote: true,
    createTeamNoteError: null,
  },
})

export const createTeamNoteSuccess = (id, { result }) => ({
  type: CREATE_TEAM_NOTE_SUCCESS,
  meta: { id },
  payload: {
    creatingTeamNote: false,
    lastUpdatedTeamNotes: Date.now(),
    teamNotes: [result.id],
  },
})

export const createTeamNoteError = (id, errorMessage) => ({
  type: CREATE_TEAM_NOTE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const updateTeamNote = (id, teamNoteId, data, formResolve, formReject) => ({
  type: UPDATE_TEAM_NOTE,
  meta: { id, teamNoteId, data, formResolve, formReject },
  payload: {
    updatingTeamNote: true,
    updateTeamNoteError: null,
  },
})

export const updateTeamNoteSuccess = id => ({
  type: UPDATE_TEAM_NOTE_SUCCESS,
  meta: { id },
  payload: {
    updatingTeamNote: false,
    lastUpdatedTeamNotes: Date.now(),
  },
})

export const updateTeamNoteError = (id, errorMessage) => ({
  type: UPDATE_TEAM_NOTE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const deleteTeamNote = (id, teamNoteId) => ({
  type: DELETE_TEAM_NOTE,
  meta: { id, teamNoteId },
  payload: {
    deletingTeamNote: true,
    deleteTeamNoteError: null,
  },
})

export const deleteTeamNoteSuccess = id => ({
  type: DELETE_TEAM_NOTE_SUCCESS,
  meta: { id },
  payload: {
    deletingTeamNote: false,
    lastUpdatedTeamNotes: Date.now(),
  },
})

export const deleteTeamNoteError = (id, errorMessage) => ({
  type: DELETE_TEAM_NOTE_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

export const interviewRequestPollingInit = (id, companySlug, candidateId) => ({
  type: INTERVIEW_REQUEST_POLLING_INIT,
  meta: { id, companySlug, candidateId },
})

export const interviewRequestPollingExecute = (id, companySlug, candidateId) => ({
  type: INTERVIEW_REQUEST_POLLING_EXECUTE,
  meta: { id, companySlug, candidateId },
})

export const interviewRequestPollingEnd = id => ({
  type: INTERVIEW_REQUEST_POLLING_END,
  meta: { id },
})

export const fetchAccountManager = id => ({
  type: FETCH_ACCOUNT_MANAGER,
  meta: { id },
  payload: {
    fetchingAccountManager: true,
    fetchAccountManagerError: null,
  },
})

export const fetchAccountManagerSuccess = (id, { result }) => ({
  type: FETCH_ACCOUNT_MANAGER_SUCCESS,
  meta: { id },
  payload: {
    fetchingAccountManager: false,
    accountManagers: [result.id],
    lastUpdatedAccountManager: Date.now(),
  },
})

export const fetchAccountManagerError = (id, errorMessage) => ({
  type: FETCH_ACCOUNT_MANAGER_ERROR,
  meta: { id },
  error: true,
  payload: new Error(errorMessage),
})

const defaultStats = {
  lastUpdated: null,
  updating: false,
  updateError: null,

  eventFeedbackId: null,
  lastUpdatedEventFeedback: null,
  creatingEventFeedback: false,
  createEventFeedbackError: null,
}

const stats = (state = defaultStats, { type, payload }) => {
  switch (type) {
    case FETCH_INTERVIEW_EVENTS_SUCCESS:
    case FETCH_EVENT_FEEDBACKS_SUCCESS:
    case CREATE_EVENT_FEEDBACK:
    case CREATE_EVENT_FEEDBACK_SUCCESS:
      return { ...state, ...payload }

    case CREATE_EVENT_FEEDBACK_ERROR:
      return { ...state, creatingEventFeedback: false, createEventFeedbackError: payload }

    default:
      return state
  }
}

const defaultMember = {
  interviewRequest: null,
  lastUpdatedInterviewRequest: null,
  fetchingInterviewRequest: false,
  fetchInterviewRequestError: null,
  withdrawingInterviewRequest: false,
  withdrawInterviewRequestError: null,
  archivingInterviewRequest: false,
  archiveInterviewRequestError: null,
  updatingInterviewRequest: false,
  updateInterviewRequestError: null,

  greenhouseProfile: null,
  lastUpdatedGreenhouseProfile: null,
  fetchingGreenhouseProfile: false,
  fetchGreenhouseProfileError: null,

  competingInterviewRequests: [],
  lastUpdatedCompetingInterviewRequests: null,
  fetchingCompetingInterviewRequests: false,
  fetchCompetingInterviewRequestsError: null,

  candidateProfile: null,
  lastUpdatedCandidateProfile: null,
  fetchingCandidateProfile: false,
  fetchCandidateProfileError: null,

  candidateAvailabilities: [],
  lastUpdatedCandidateAvailabilities: null,
  fetchingCandidateAvailabilities: false,
  fetchCandidateAvailabilitiesError: null,

  messages: [],
  lastUpdatedMessages: null,
  fetchingMessages: false,
  fetchMessagesError: null,
  creatingMessage: false,
  createMessageError: null,
  updatingMessage: false,
  updateMessageError: null,

  offers: [],
  lastUpdatedOffers: null,
  fetchingOffers: false,
  fetchOffersError: null,
  creatingOffer: false,
  createOfferError: null,

  interviewEvents: [],
  lastUpdatedInterviewEvents: null,
  fetchingInterviewEvents: false,
  fetchInterviewEventsError: null,
  eventToGiveFeedback: null,

  eventFeedbacks: [],
  lastUpdatedEventFeedbacks: null,
  fetchingEventFeedbacks: false,
  fetchEventFeedbacksError: null,

  interviewEventStats: {},

  members: [],
  lastUpDatedMembers: null,
  fetchingMembers: false,
  fetchMembersError: null,

  teamNotes: [],
  lastUpdatedTeamNotes: null,
  fetchingTeamNotes: false,
  fetchTeamNotesError: null,
  creatingTeamNote: false,
  createTeamNoteError: null,
  deletingTeamNote: false,
  deletingTeamNoteError: null,

  accountManagers: [],
  fetchingAccountManager: false,
  fetchAccountManagerError: null,
  lastUpdatedAccountManager: null,
}

const member = (state = defaultMember, { meta, type, payload }) => {
  switch (type) {
    case FETCH_INTERVIEW_REQUEST:
    case FETCH_INTERVIEW_REQUEST_SUCCESS:
    case FETCH_GREENHOUSE_PROFILE:
    case FETCH_GREENHOUSE_PROFILE_SUCCESS:
    case FETCH_COMPETING_INTERVIEW_REQUESTS:
    case FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS:
    case FETCH_CANDIDATE_AVAILABILITIES:
    case FETCH_CANDIDATE_AVAILABILITIES_SUCCESS:
    case FETCH_MESSAGES:
    case FETCH_MESSAGES_SUCCESS:
    case CREATE_MESSAGE:
    case UPDATE_MESSAGE:
    case UPDATE_MESSAGE_SUCCESS:
    case WITHDRAW_INTERVIEW_REQUEST:
    case ARCHIVE_INTERVIEW_REQUEST:
    case ARCHIVE_INTERVIEW_REQUEST_SUCCESS:
    case UPDATE_INTERVIEW_REQUEST:
    case UPDATE_INTERVIEW_REQUEST_SUCCESS:
    case TOGGLE_EVENT_FEEDBACK:
    case FETCH_OFFERS:
    case FETCH_OFFERS_SUCCESS:
    case CREATE_OFFER:
    case FETCH_INTERVIEW_EVENTS:
    case CREATE_INTERVIEW_EVENT:
    case FETCH_EVENT_FEEDBACKS:
    case FETCH_MEMBERS:
    case FETCH_MEMBERS_SUCCESS:
    case FETCH_TEAM_NOTES:
    case FETCH_TEAM_NOTES_SUCCESS:
    case CREATE_TEAM_NOTE:
    case UPDATE_TEAM_NOTE:
    case UPDATE_TEAM_NOTE_SUCCESS:
    case DELETE_TEAM_NOTE:
    case DELETE_TEAM_NOTE_SUCCESS:
    case FETCH_ACCOUNT_MANAGER:
    case FETCH_ACCOUNT_MANAGER_SUCCESS:
      return { ...state, ...payload }

    case FETCH_INTERVIEW_REQUEST_ERROR:
      return { ...state, fetchingInterviewRequest: false, fetchInterviewRequestError: payload }

    case FETCH_GREENHOUSE_PROFILE_ERROR:
      return { ...state, fetchingGreenhouseProfile: false, fetchGreenhouseProfileError: payload }

    case FETCH_COMPETING_INTERVIEW_REQUESTS_ERROR:
      return { ...state, fetchingCompetingInterviewRequests: false, fetchCompetingInterviewRequests: payload }

    case FETCH_CANDIDATE_AVAILABILITIES_ERROR:
      return { ...state, fetchingCandidateAvailabilities: false, fetchCandidateAvailabilitiesError: payload }

    case FETCH_MESSAGES_ERROR:
      return { ...state, fetchingMessages: false, fetchMessagesError: payload }

    case CREATE_MESSAGE_SUCCESS:
      return { ...state, ...payload, messages: [...payload.messages, ...state.messages] }

    case CREATE_MESSAGE_ERROR:
      return { ...state, creatingMessage: false, createMessageError: payload }

    case UPDATE_MESSAGE_ERROR:
      return { ...state, updatingMessage: false, updateMessageError: payload }

    case WITHDRAW_INTERVIEW_REQUEST_ERROR:
      return { ...state, withdrawingInterviewRequest: false, withdrawInterviewRequestError: payload }

    case ARCHIVE_INTERVIEW_REQUEST_ERROR:
      return { ...state, archivingInterviewRequest: false, archiveInterviewRequestError: payload }

    case UPDATE_INTERVIEW_REQUEST_ERROR:
      return { ...state, updatingInterviewRequest: false, updateInterviewRequestError: payload }

    case FETCH_INTERVIEW_EVENTS_SUCCESS:
      return {
        ...state,
        ...payload,
        interviewEventStats: {
          ...state.interviewEventStats,
          ...payload.interviewEvents.reduce((map, eventId) => {
            map[eventId] = stats(state.interviewEventStats[eventId], { type })
            return map
          }, {}),
        },
      }

    case FETCH_INTERVIEW_EVENTS_ERROR:
      return { ...state, fetchingInterviewEvents: false, fetchInterviewEventsError: payload }

    case FETCH_EVENT_FEEDBACKS_ERROR:
      return { ...state, fetchingEventFeedbacks: false, fetchEventFeedbacksError: payload }

    case FETCH_EVENT_FEEDBACKS_SUCCESS:
      return {
        ...state,
        ...payload,
        interviewEventStats: {
          ...state.interviewEventStats,
          ...payload.interviewEventStats.reduce((map, item) => {
            map[item.meta.eventId] = stats(state.interviewEventStats[item.meta.eventId], { type, payload: item.payload })
            return map
          }, {}),
        },
      }

    case CREATE_INTERVIEW_EVENT_ERROR:
      return { ...state, creatingInterviewEvent: false, createInterviewEventError: payload }

    case CREATE_INTERVIEW_EVENT_SUCCESS:
      return {
        ...state,
        ...payload,
        interviewEvents: [...payload.interviewEvents, ...state.interviewEvents],
        interviewEventStats: {
          ...state.interviewEventStats,
          ...payload.interviewEventStats,
        },
      }

    case CREATE_EVENT_FEEDBACK:
    case CREATE_EVENT_FEEDBACK_ERROR:
      return {
        ...state,
        interviewEventStats: {
          ...state.interviewEventStats,
          [meta.eventId]: stats(state.interviewEventStats[meta.eventId], { type, payload }),
        },
      }

    case CREATE_EVENT_FEEDBACK_SUCCESS:
      return {
        ...state,
        eventFeedbacks: [...payload.eventFeedbacks, ...state.eventFeedbacks],
        interviewEventStats: {
          ...state.interviewEventStats,
          [meta.eventId]: stats(state.interviewEventStats[meta.eventId], { type, payload: payload.interviewEventStats }),
        },
      }

    case FETCH_OFFERS_ERROR:
      return { ...state, fetchingOffers: false, fetchOffersError: payload }

    case CREATE_OFFER_SUCCESS:
      return { ...state, ...payload, offers: [...payload.offers, ...state.offers] }

    case CREATE_OFFER_ERROR:
      return { ...state, creatingOffer: false, createOfferError: payload }

    case FETCH_MEMBERS_ERROR:
      return { ...state, fetchingMembers: false, fetchMembersError: payload }

    case FETCH_TEAM_NOTES_ERROR:
      return { ...state, fetchingTeamNotes: false, fetchTeamNotesError: payload }

    case CREATE_TEAM_NOTE_SUCCESS:
      return { ...state, ...payload, teamNotes: [...payload.teamNotes, ...state.teamNotes] }

    case CREATE_TEAM_NOTE_ERROR:
      return { ...state, creatingTeamNote: false, createTeamNoteError: payload }

    case UPDATE_TEAM_NOTE_ERROR:
      return { ...state, updatingTeamNote: false, updateTeamNoteError: payload }

    case DELETE_TEAM_NOTE_ERROR:
      return { ...state, deletingTeamNote: false, deleteTeamNoteError: payload }

    case FETCH_ACCOUNT_MANAGER_ERROR:
      return { ...state, fetchingAccountManager: false, fetchAccountManagerError: payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case FETCH_INTERVIEW_REQUEST:
    case FETCH_INTERVIEW_REQUEST_SUCCESS:
    case FETCH_INTERVIEW_REQUEST_ERROR:
    case FETCH_GREENHOUSE_PROFILE:
    case FETCH_GREENHOUSE_PROFILE_SUCCESS:
    case FETCH_GREENHOUSE_PROFILE_ERROR:
    case FETCH_COMPETING_INTERVIEW_REQUESTS:
    case FETCH_COMPETING_INTERVIEW_REQUESTS_SUCCESS:
    case FETCH_COMPETING_INTERVIEW_REQUESTS_ERROR:
    case FETCH_CANDIDATE_AVAILABILITIES:
    case FETCH_CANDIDATE_AVAILABILITIES_SUCCESS:
    case FETCH_CANDIDATE_AVAILABILITIES_ERROR:
    case FETCH_MESSAGES:
    case FETCH_MESSAGES_SUCCESS:
    case FETCH_MESSAGES_ERROR:
    case CREATE_MESSAGE:
    case CREATE_MESSAGE_SUCCESS:
    case CREATE_MESSAGE_ERROR:
    case UPDATE_MESSAGE:
    case UPDATE_MESSAGE_SUCCESS:
    case UPDATE_MESSAGE_ERROR:
    case WITHDRAW_INTERVIEW_REQUEST:
    case WITHDRAW_INTERVIEW_REQUEST_ERROR:
    case ARCHIVE_INTERVIEW_REQUEST:
    case ARCHIVE_INTERVIEW_REQUEST_SUCCESS:
    case ARCHIVE_INTERVIEW_REQUEST_ERROR:
    case UPDATE_INTERVIEW_REQUEST:
    case UPDATE_INTERVIEW_REQUEST_SUCCESS:
    case UPDATE_INTERVIEW_REQUEST_ERROR:
    case FETCH_INTERVIEW_EVENTS:
    case FETCH_INTERVIEW_EVENTS_SUCCESS:
    case FETCH_INTERVIEW_EVENTS_ERROR:
    case CREATE_INTERVIEW_EVENT:
    case CREATE_INTERVIEW_EVENT_SUCCESS:
    case CREATE_INTERVIEW_EVENT_ERROR:
    case FETCH_EVENT_FEEDBACKS:
    case FETCH_EVENT_FEEDBACKS_SUCCESS:
    case FETCH_EVENT_FEEDBACKS_ERROR:
    case TOGGLE_EVENT_FEEDBACK:
    case CREATE_EVENT_FEEDBACK:
    case CREATE_EVENT_FEEDBACK_SUCCESS:
    case CREATE_EVENT_FEEDBACK_ERROR:
    case FETCH_OFFERS:
    case FETCH_OFFERS_SUCCESS:
    case FETCH_OFFERS_ERROR:
    case CREATE_OFFER:
    case CREATE_OFFER_SUCCESS:
    case CREATE_OFFER_ERROR:
    case FETCH_MEMBERS:
    case FETCH_MEMBERS_SUCCESS:
    case FETCH_MEMBERS_ERROR:
    case FETCH_TEAM_NOTES:
    case FETCH_TEAM_NOTES_SUCCESS:
    case FETCH_TEAM_NOTES_ERROR:
    case CREATE_TEAM_NOTE:
    case CREATE_TEAM_NOTE_SUCCESS:
    case CREATE_TEAM_NOTE_ERROR:
    case UPDATE_TEAM_NOTE:
    case UPDATE_TEAM_NOTE_SUCCESS:
    case UPDATE_TEAM_NOTE_ERROR:
    case DELETE_TEAM_NOTE:
    case DELETE_TEAM_NOTE_SUCCESS:
    case DELETE_TEAM_NOTE_ERROR:
    case FETCH_ACCOUNT_MANAGER:
    case FETCH_ACCOUNT_MANAGER_SUCCESS:
    case FETCH_ACCOUNT_MANAGER_ERROR:
      return {
        ...state,
        [meta.id]: member(state[meta.id], { meta, type, payload }),
      }

    case WITHDRAW_INTERVIEW_REQUEST_SUCCESS:
      const { [meta.id]: toRemove, ...newState } = state
      return newState

    default:
      return state
  }
}

export default map

export const getInterviewRequestDetailsView = (state, id) => state.views.interviewRequestDetails[id] || defaultMember
